import { RouterProvider } from '@tanstack/react-router';

import { router } from '@/setup/router';

export function App() {
  return <RouterProvider router={router} />;
}
